import axios from "axios";
import { GET_ALL_NOTIFICATION, GET_UNREAD_NOTIFICATION } from "../actions";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const PROXY = process.env.REACT_APP_URL + "api/";

// Get Notification
export const getNotification = (page, limit, search) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${PROXY}notification/owner/all?page=${page}&limit=${limit}&search=${search}`
    );
    dispatch({
      type: GET_ALL_NOTIFICATION,
      payload: res.data.result,
    });
    return res.data.result;
  } catch (err) {
    console.error(err);
    //   toast.error(err.response.data.message);
  }
};

export const getUnreadData = () => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}notification/owner/count`);
    dispatch({
      type: GET_UNREAD_NOTIFICATION,
      payload: res.data.result.unread,
    });
    return res.data.result;
  } catch (err) {
    console.error(err);
  }
};

export const notificationAlert = (data) => async () => {
  const res = await axios.post(`${PROXY}notification/read/unread`, data);
  return res;
};
export const getApplicationUnreadData = () => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}notification/application/unread`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};
